import React from "react";

const ReaderFormFields = ({ reader, disabled, onChange, user }) => (
  <React.Fragment>
    <div className="form-group">
      <label className="control-label" htmlFor="reader">
        Leser (betegnelse)
      </label>
      <input
        onChange={e => onChange(["reader", "name"], e.target.value)}
        id="reader"
        name="reader"
        type="text"
        placeholder="Navn/Adresse"
        value={reader.name}
        className="form-control input-md"
        disabled={disabled}
      />
    </div>
    <div className="form-group">
      <label className="control-label" htmlFor="location">
        Selskap
      </label>
      <div className="input-group mb-2">
        <select
          onChange={e => onChange(["reader", "user_id"], e.target.value)}
          id="company"
          name="company"
          value={reader.user_id}
          className="form-control"
          required
        >
          <option value="">Velg</option>
          {user.map(item => (
            <option key={item.id} value={item.id}>
              {item.company}
            </option>
          ))}
        </select>
      </div>
    </div>
  </React.Fragment>
);

export default ReaderFormFields;



// WEBPACK FOOTER //
// ./src/components/ReaderFormFields.js